import React, { useRef, useState, useEffect } from "react";
import {
  getIntellectStatus,
  addCommentIntellect,
  multipleDownloadFile,
} from "../apiSection/apiUrlConstent";
import service from "../apiSection/service";
import { ShowAlert } from "../Common/Components/Alert";
import Loading from "../Common/Components/Loading";
import { makeStyles } from "@mui/styles";
import { Box, Typography, Grid, Button, IconButton } from "@mui/material";
import { dateFormatter } from "../Utils/dateFormatter";
import FileList from "../Common/Components/FilesList";
import TextArea from "../Common/Components/TextArea";
import { useForm } from "react-hook-form";
import { Avatar } from "@mui/material";
import ReplyOutlinedIcon from "@mui/icons-material/ReplyOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Divider } from "@mui/material";

const useStyles = makeStyles(() => ({
  heading: {
    padding: "15px",
  },
  cardsData: {
    background: "white",
  },
  cardUserData: {
    backgroundColor: "#F5F8FF",
    padding: "20px",
    borderRadius: "8px",
  },
  cardUserDetails: {
    backgroundColor: "#F5F8FF",
    borderRadius: "8px",
  },
  userDatamap: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  userDatalabel: {
    color: "#707EAE",
    wordWrap: "break-word",
    maxWidth: "200px",
    fontSize: "15px",
    whiteSpace: "normal",
  },
  label: {
    color: "#24A7DC",
    fontWeight: "600",
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "10px",
    fontSize: "20px",
  },
  alignColumn: { display: "flex", flexDirection: "column", gap: "10px" },
  align: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  font: { fontWeight: "600" },
  noHistory: {
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    color: "#707EAE",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
  },
  name: {
    fontWeight: 600,
    color: "#000000",
    fontSize: "14px",
  },
  createdAt: {
    marginBottom: "5px",
    fontSize: "12px",
    color: "#0E184B",
  },
  comments: {
    marginTop: "10px",
    fontWeight: 600,
    fontSize: "14px",
    color: "#807979",
    marginLeft: "45px",
  },
  rplySection: {
    padding: "10px",
    display: "flex",
    alignItems: "center",
    display: "flex",
    justifyContent: "end",
    cursor: "pointer",
  },
  rplyText: {
    color: "#0FA5D9",
    textDecoration: "underline",
    fontWeight: 700,
    fontSize: "16px",
    cursor: "pointer",
  },
  loadMore: {
    background: "#707EAE26",
    marginTop: "15px",
    marginBottom: "20px",
    padding: "15px",
    borderRadius: "8px",
    border: "1px solid #E0E0E1 ",
    display: "flex",
    justifyContent: "center",
    cursor: "pointer",
  },
  commentTypeHeading: {
    marginBottom: "8px",
    fontSize: "14px",
    textTransform: "uppercase",
    color: "#555",
  },
}));

export default function IntellectDetails(props) {
  const {
    register,
    control,
    setValue,
    formState: { errors },
    watch,
    trigger,
    reset,
  } = useForm();
  const [intellectData, setIntellectData] = useState({});
  const [commentsData, setCommentsData] = useState([]);
  const [ticketingComments, setTicketingComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showTextArea, setShowTextArea] = useState(false);
  const [visibleComments, setVisibleComments] = useState(3);
  const [combinedComments, setCombinedComments] = useState([]);
  const [ticketingMessage, setTicketingMessage] = useState(null);
  const [intellectMessage, setIntellectMessage] = useState(null);
  const textAreaRef = useRef(null);
  const classes = useStyles();

  const mimeTypes = {
    pdf: "application/pdf",
    pdf: "application/zip",
    png: "image/png",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    txt: "text/plain",
    csv: "text/csv",
    json: "application/json",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    png: "image/png",
    jpeg: "image/jpeg",
    jpg: "image/jpeg",
    gif: "image/gif",
    pdf: "application/pdf",
    txt: "text/plain",
    html: "text/html",
    css: "text/css",
    js: "application/javascript",
    json: "application/json",
    xml: "application/xml",
    csv: "text/csv",
    zip: "application/zip",
    tar: "application/x-tar",
    mp4: "video/mp4",
    mov: "video/quicktime",
    avi: "video/x-msvideo",
    mkv: "video/x-matroska",
    mp3: "audio/mpeg",
    wav: "audio/wav",
    ogg: "audio/ogg",
    webm: "video/webm",
    flv: "video/x-flv",
    svg: "image/svg+xml",
    bmp: "image/bmp",
    tiff: "image/tiff",
    ico: "image/x-icon",
    wmv: "video/x-ms-wmv",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    jsonld: "application/ld+json",
    eot: "application/vnd.ms-fontobject",
    otf: "font/otf",
    ttf: "font/ttf",
    woff: "font/woff",
    woff2: "font/woff2",
    mpkg: "application/vnd.apple.installer+xml",
    xul: "application/vnd.mozilla.xul+xml",
    eps: "application/postscript",
    ai: "application/postscript",
    psd: "image/vnd.adobe.photoshop",
    ics: "text/calendar",
    key: "application/vnd.apple.keynote",
    rar: "application/x-rar-compressed",
    "7z": "application/x-7z-compressed",
    webp: "image/webp",
    flac: "audio/flac",
    m4a: "audio/mp4",
    m4v: "video/x-m4v",
    oga: "audio/ogg",
    oga: "audio/ogg",
    ogv: "video/ogg",
  };

  useEffect(() => {
    handleIntellectDetails();
  }, []);

 
  const handleIntellectDetails = () => {
    setLoading(true);
    const postObj = {
      tckt_id: props.rowData?.tckt_id,
      call_from: "INTELLECT_TAB",
    };

    service
      .create(getIntellectStatus, postObj)
      .then((res) => {
        const ticketingData = res?.data?.ticketing_tool_comment_details;
        const intellectData = res?.data?.intellect_comment_details;

        let ticketing = [];
        let intellect = [];

        // Check for ticketing comments
        if (Array.isArray(ticketingData)) {
          ticketing = ticketingData.map((item) => ({
            type: "ticketing",
            id: item.id,
            body: item.body,
            created_at: item.created_at,
            full_name: item.full_name,
            file_name: item.file_name,
            attachment: item.attachment,
          }));
        }

        // Check for intellect comments
        if (Array.isArray(intellectData)) {
          intellect = intellectData.map((item) => ({
            type: "intellect",
            id: item.id,
            body: item.body,
            created_at: item.created_at,
            full_name: item.user?.full_name,
            profile_pic: item.user?.profile_pic,
            attach: item.attach,
          }));
        }

        const combined = [...ticketing, ...intellect].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

        setCombinedComments(combined);
        setTicketingMessage(
          !Array.isArray(ticketingData) ? ticketingData : null
        );
        setIntellectMessage(
          !Array.isArray(intellectData) ? intellectData : null
        );
        setIntellectData(res.data.ticket_details?.data || {});
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        ShowAlert({
          icon: "error",
          text: "Ticket not found",
          width: "400px",
        });
      });
  };

  const stripHTML = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const scrollToElement = () => {
    const targetElement = document.getElementById("reply_text_area");

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  const handleReplyClick = () => {
    setShowTextArea(true);
    setTimeout(() => {
      scrollToElement();
    }, 200);
  };

  const handleLoadMore = () => {
    setVisibleComments((prev) => prev + 3);
  };
  const handleCancel = () => {
    setShowTextArea(false);
  };
  const handleSubmit = () => {
    setLoading(true);
    const reason = watch("reason");
    const postObj = {
      tckt_id: props.rowData?.tckt_id,
      content: reason,
    };
    service
      .create(addCommentIntellect, postObj)
      .then((res) => {
        console.log("addcomments", res);
        setLoading(false);
        if (res.status === 200) {
          ShowAlert({
            icon: "success",
            text: res.data.message,
            width: "400px",
          });
          reset({ reason: "" });
          handleIntellectDetails();
          setShowTextArea(false);
        }
      })
      .catch(() => {
        setLoading(false);
        ShowAlert({
          icon: "error",
          text: "comment not found",
          width: "400px",
        });
      });
  };
  const handleDownload = (data, key) => {
    setLoading(true);

    const downloadFiles = (attachmentPath) => {
      const postData = { path: attachmentPath };
      service
        .create(multipleDownloadFile, postData)
        .then((res) => {
          setLoading(false);

          if (res.status === 200 && res.data?.result?.file_url) {
            // Case: Direct file URL
            window.open(res.data.result.file_url, "_blank");
          } else if (res.status === 200 && res.data?.result?.flag === true) {
            // Case: Base64 Download
            const fileData = res.data.result;

            if (!fileData?.base64 || !fileData?.extension) {
              console.error("Invalid file data received.");
              return;
            }

            const fileName =
              fileData.file_name?.trim() ||
              props.rowData?.file_name ||
              "download";

            const mimeType =
              mimeTypes[fileData.extension.toLowerCase()] ||
              "application/octet-stream";

            const link = document.createElement("a");
            link.href = `data:${mimeType};base64,${fileData.base64}`;
            link.download = `${fileName}.${fileData.extension}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            ShowAlert({
              icon: "error",
              text: "Unable to download the file.",
              width: "400px",
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          ShowAlert({
            icon: "error",
            text: error.response?.data?.message || "Download failed.",
            width: "400px",
          });
        });
    };

    const handleFileDownload = (attachmentKey) => {
      const attachmentPath = data[attachmentKey];
      if (attachmentPath) {
        downloadFiles(attachmentPath);
      } else {
        setLoading(false);
        ShowAlert({
          icon: "error",
          text: "No files available for download.",
          width: "400px",
        });
      }
    };

    if (key === "createDownload") {
      handleFileDownload("attachment");
    }
  };

  return (
    <div>
      <Loading open={loading} />
      {combinedComments?.length > 0 ? (
  <div className={classes.alignColumn}>
    {[...combinedComments]
      .reverse()
      .slice(0, visibleComments)
      .map((comment, index, arr) => {
        const showTypeHeading =
          index === 0 || comment.type !== arr[index - 1]?.type;

        return (
          <React.Fragment key={comment.id || index}>
            {showTypeHeading && (
              <Typography
                variant="subtitle2"
                className={classes.commentTypeHeading}
                sx={{ marginTop: 2, fontWeight: 600, color: "#444" }}
              >
                {comment.type === "ticketing"
                  ? "Machint"
                  : "Intellect"}
              </Typography>
            )}

            <Box sx={{ padding: "16px", borderRadius: "8px" }}>
              <div className={classes.align}>
                <Avatar
                  alt={comment.full_name || "Unknown User"}
                  src={comment.profile_pic || ""}
                  sx={{ width: 40, height: 40 }}
                />
                <div className={classes.textContainer}>
                  <div className={classes.name}>
                    {comment.full_name || "Unknown User"}
                  </div>
                  <div className={classes.createdAt}>
                    {dateFormatter(comment.created_at)}
                  </div>
                </div>
              </div>

              <div className={classes.comments}>
                <span>
                  {comment.type === "intellect"
                    ? stripHTML(comment.body)
                    : comment.body || "-"}
                </span>
              </div>

              {comment.type === "ticketing" && comment.attachment && (
                <Box className={classes.downloadContainer}>
                  <IconButton
                    sx={{ color: "#0FA5D9" }}
                    onClick={() => handleDownload(comment, "createDownload")}
                  >
                    <FileDownloadOutlinedIcon />
                  </IconButton>
                  <Typography
                    variant="body2"
                    sx={{
                      display: "inline",
                      marginRight: "8px",
                      fontWeight: 500,
                    }}
                  >
                    {comment.file_name || "Download File"}
                  </Typography>
                </Box>
              )}

              {comment.type === "intellect" && comment.attach?.length > 0 && (
                <FileList attachments={comment.attach} />
              )}
            </Box>

            <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />
          </React.Fragment>
        );
      })}
  </div>
) : (
  <div className={classes.alignColumn}>
    {ticketingMessage && (
      <Typography variant="body2" className={classes.noHistory}>
        {ticketingMessage}
      </Typography>
    )}
    {intellectMessage && (
      <Typography variant="body2" className={classes.noHistory}>
        {intellectMessage}
      </Typography>
    )}
    {!ticketingMessage && !intellectMessage && (
      <Typography marginTop="15%" className={classes.noHistory}>
        No Comments Found
      </Typography>
    )}
  </div>
)}


      {combinedComments.length > visibleComments && (
        <div className={classes.loadMore} onClick={handleLoadMore}>
          <Typography variant="body2" color="text.secondary">
            <span
              style={{
                fontWeight: 600,
                fontSize: "14px",
                color: "#000000",
              }}
            >
              Load More
            </span>
          </Typography>
        </div>
      )}

      {showTextArea && (
        <Box display="flex" flexDirection="column" gap={2}>
          <TextArea
            // ref={textAreaRef}
            id="reply_text_area"
            name="reason"
            minRows={4}
            label="Leave a Reply"
            marginTop="4px"
            placeholder=""
            width="98%"
            maxlength={300}
            inputRef={register("reason", {
              required: true,
            })}
          />
          <Box display="flex" justifyContent="flex-end" gap={1}>
            <Button onClick={handleCancel} variant="outlined">
              Cancel
            </Button>
            <Button onClick={handleSubmit} variant="contained">
              Submit
            </Button>
          </Box>
        </Box>
      )}
    </div>
  );
}
